import { render } from "./SliceBasic.vue?vue&type=template&id=1f86af08&scoped=true&ts=true"
import script from "./SliceBasic.vue?vue&type=script&lang=ts"
export * from "./SliceBasic.vue?vue&type=script&lang=ts"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f86af08"]])

export default __exports__